import React from "react";
import {
  TextInput,
  Edit,
  SimpleForm,
  DateTimeInput,
  NumberInput,
  SelectInput,
} from "react-admin";

export const VoucherEdit = (props) => (
  <Edit {...props} title="쿠폰 수정">
    <SimpleForm>
      <TextInput source="title" label="쿠폰이름" />
      <TextInput source="description" label="쿠폰내용" />
      <TextInput source="code" label="쿠폰번호" />
      <SelectInput
        source="discount_type"
        label="할인타입"
        choices={[
          { id: "percent", name: "퍼센트(%)" },
          { id: "price", name: "금액(원)" },
        ]}
      />
      <NumberInput source="discount_rate" label="할인률" />
      <NumberInput source="count" label="쿠폰 수량" />
      <DateTimeInput source="expiredAt" label="만료일자" />
    </SimpleForm>
  </Edit>
);
